import { Select } from "@mantine/core";
import { IconFilter } from "@tabler/icons-react";

export interface FilterChip {
  value: string;
  label: string;
  count: number;
  colors?: { bg: string; border: string; text: string };
}

const c = {
  slate400: "#94a3b8",
  slate500: "#64748b",
  slate800: "#1e293b",
  slate900: "#0f172a",
  border: "#e2e8f0",
  white: "#ffffff",
  slate50: "#f8fafc",
};

export function FilterChips({
  chips,
  active,
  onChange,
  compact = false,
}: {
  chips: FilterChip[];
  active: string;
  onChange: (value: string) => void;
  compact?: boolean;
}) {
  if (compact) {
    return (
      <Select
        data={chips.map((chip) => ({ value: chip.value, label: `${chip.label} (${chip.count})` }))}
        value={active}
        onChange={(v) => v && onChange(v)}
        allowDeselect={false}
        leftSection={<IconFilter size={16} />}
        aria-label="Status filter"
        w="100%"
      />
    );
  }

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
      {chips.map((chip) => {
        const isActive = active === chip.value;
        const p = chip.colors;
        return (
          <button
            key={chip.value}
            type="button"
            onClick={() => onChange(chip.value)}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              padding: "6px 12px",
              borderRadius: 999,
              fontSize: 12,
              fontWeight: 700,
              cursor: "pointer",
              transition: "all 120ms ease",
              border: `1px solid ${isActive ? (p ? p.border : c.slate800) : c.border}`,
              background: isActive ? (p ? p.bg : c.slate900) : c.white,
              color: isActive ? (p ? p.text : c.white) : c.slate500,
            }}
          >
            {chip.label}
            <span
              style={{
                fontSize: 11,
                fontWeight: 700,
                minWidth: 16,
                textAlign: "center",
                padding: "0 5px",
                borderRadius: 999,
                background: isActive
                  ? p
                    ? "rgba(255,255,255,0.6)"
                    : "rgba(255,255,255,0.22)"
                  : c.slate50,
                color: isActive ? (p ? p.text : c.white) : c.slate400,
              }}
            >
              {chip.count}
            </span>
          </button>
        );
      })}
    </div>
  );
}
